import { render } from "./ImagePopup.vue?vue&type=template&id=080398a6&scoped=true"
import script from "./ImagePopup.vue?vue&type=script&lang=js"
export * from "./ImagePopup.vue?vue&type=script&lang=js"

import "./ImagePopup.vue?vue&type=style&index=0&id=080398a6&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080398a6"]])

export default __exports__